module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"status":"Status","type":"Payment type","itemType":"Service type","id":"Billing ID","date":"Date","amount":"Amount","noPayments":"No payments yet","tariff":"Tariff"}}')
  delete Component.options._Ctor
}
